import Swiper from "swiper";

const ArticleCategorySlider = function () {

    const sections = document.querySelectorAll( '.article-category-slider' );

    for (const section of sections) {
        const swiperEl = section.querySelector( '.swiper' );
        const swiper = new Swiper(swiperEl, {
            slidesPerView: 'auto',
            spaceBetween: 8,
            centeredSlides: true,
            loop: true,
        })
    }

}
  
export default ArticleCategorySlider